module.exports = __webpack_public_path__ + "media/images/athletes/2133-0c62cc32b5f654cf9823ac76e99d0082.png";